// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var LegalEntityEditSettingsController = function ($scope, $rootScope, $routeParams, $location, legalEntityService, gettextCatalog, gettext) {

    function finish(parentId) {
        if (parentId ) {
            $location.path("/account-settings/legal-entity/" + parentId );
        } else {
            $location.path("/account-settings/legal-entity");
        }
    }

    if ($routeParams.entityId) {
        legalEntityService.get({ entityId: $routeParams.entityId }, function(response){
            $scope.legalEntity = response;
            $scope.breadcrumbs = $scope.legalEntity.Breadcrumbs;
        });
    }
    else if ($routeParams.parentId) {
        $scope.legalEntity = new legalEntityService();
        $scope.legalEntity.ParentId = $routeParams.parentId;

        legalEntityService.get({ entityId: $routeParams.parentId }, function(response){
            $scope.parentEntity = response;
            $scope.breadcrumbs = $scope.parentEntity.Breadcrumbs;
            $scope.breadcrumbs.push({Name: gettextCatalog.getString(gettext("New sub-entity"))})
        });        
    }
    else {
        finish();
    }

    $scope.cancel = finish.bind(null, $routeParams.parentId);

    $scope.save = function () {
        if (!$rootScope.isValid($scope.form)) {
            return;
        }

        if ($routeParams.entityId) {
            $scope.legalEntity.$update({ entityId: $routeParams.entityId }, $scope.cancel);
        } else {
            $scope.legalEntity.$create({ }, $scope.cancel);
        }
    };

    $scope.dataValid = function () {
        return !$scope.form.creditorIdentifier.$invalid &&
            !$scope.form.vatId.$invalid &&
            !$scope.form.nationalCompanyId.$invalid &&
            !$scope.form.iban.$invalid &&
            !$scope.form.bic.$invalid &&
            !$scope.form.qriban.$invalid &&
            !$scope.form.qriban.$invalid;
    };
};
LegalEntityEditSettingsController.$inject = ['$scope', '$rootScope', '$routeParams', '$location', 'LegalEntities', 'gettextCatalog', 'gettext',];
